export default "__VITE_ASSET__C_9m88A2__"